// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "immutable/" + chunkId + "." + {"2023":"05a086dfa257fd19a951","2146":"0f6742a3e605173d3ff5","5451":"e56820f89bfb32e067e3","5925":"43c521136706fb2a015f"}[chunkId] + ".chunk.css";
};